import type {
  schemaType,
  returnType,
} from '~~/shared/api/strapi/vacaciones-landings/list/schema'
import {
  strapiServerFetchWrapper,
  strapiBrowserFetchWrapper,
} from '~~/server/utils/strapi/endpointWrapper'

const endpoint = '/vacaciones-landings/list'

export const serverFetch = (): Promise<returnType> =>
  strapiServerFetchWrapper<never, schemaType>(endpoint)

export const browserFetch = (): Promise<returnType> =>
  strapiBrowserFetchWrapper<never, schemaType>(endpoint)
